export class Address {
    addressid: number = null;
    addressstreet: string = null;
    addresshousenumber: string = null;
    addressnote: string = null;
    addressaddition: string = null;
    addresszipcode: string = null;
    addresscity: string = null;
    addresscountry: string = 'Deutschland';
}

export class Availability {
    availabilityid: number = null;
    availabilitylocation: number = null;
    availabilitystate: number = null;
    availabilitycomponent: number = null;
    availabilityState: AvailabilityStatus;
    availabilityComponent: AvailabilityComponent;
}

export class AvailabilityStatus {
    availabilitystateid: number = null;
    availabilitystatename: string = null;
    availabilitystatedeliverymin: number = null;
    availabilitystatedeliverymax: number = null;
    availabilitystatedesc: string = null;
}

export class AvailabilityComponent {
    availabilitycomponentid: number = null;
    availabilitycomponentname: string = null;
    availabilitycomponentrequirement: number = null;
    availabilityRequirement: AvailabilityRequirement;
}

export class AvailabilityRequirement {
    availabilityrequirementid: number = null;
    availabilityrequirementname: string = null;
    availabilityrequirementdesc: string = null;
}

export class Location {
    locationid: number = null;
    locationfloor: string = null;
    locationpart: string = null;
    locationparent: number = null;
    locationclassification: number = null;
    locationinfo: string = null;
    locationaddress: number = null;
    availability: Availability[];
    address: Address;
}

export class LocationAlias {
    locationaliasid: number = null;
    locationid: number = null;
    locationaliastype: number = null;
    locationaaliascode: string = null;
    location: Location;
    locationAliasType: LocationAliasType;
}

export class LocationAliasType {
    typeid: number = null;
    typename: string = null;
    typedesc: string = null;
}
